import { combineReducers } from 'redux';
import auth from './auth';
import station from './station';
import maps from './maps';
import lists from './lists';
import gasFormula from './gasFormula';
import rackFormula from './rackFormula';
import general from './general';
import report from './report';
import reportsMonitoring from './reports/monitoring';
import reportsGasBuddyPrices from './reports/gasBuddyPrices';
import notifier from './notifier';
import registry from './registry';
import logisticsDelivery from './logistics/stationDelivery';
import stationInvoices from './accounting/stationInvoice';
import bulkInvoices from './accounting/bulkInvoice';
import rackTransfers from './accounting/rackTransfer';
import pricingRequests from './retailPricing/pricingRequest';
import vendorBills from './billing/vendorBill';
import inventoryAllocation from './inventory/inventoryAllocation';

import { connectRouter } from 'connected-react-router';

//import user from './user';

export default (history) =>
	combineReducers({
		router: connectRouter(history),
		auth,
		bulkInvoices,
		gasFormula,
		general,
		inventoryAllocation,
		logisticsDelivery,
		lists,
		maps,
		notifier,
		rackFormula,
		rackTransfers,
		pricingRequests,
		registry,
		report,
		reportsMonitoring,
		reportsGasBuddyPrices,
		station,
		stationInvoices,
		vendorBills,
		//user,
	});
